import { cn } from 'lib/utils';
import { SearchIcon } from 'asset/icons';
import React from 'react'
import { InputNumberFormat } from '@react-input/number-format';

const TableSearchInput = ({onChange}) => {
  return (
      <div
          className={`flex bg-[#EAECF0] items-center rounded-lg  375:!mr-3 !pl-4 w-auto 400:w-[240px] md:w-[264px]`}
      >
          <SearchIcon className="-order-2 size-5" />
          <input
              required={true}
              placeholder={"Search"}
              className={
                  "!h-[40px] bg-[#EAECF0] !pl-2 !shadow-[inset_0_0_0_1000px_#EAECF0] rounded-lg"
              }
              onChange={(evt) => onChange(evt.target.value)}
              type={"text"}
          />
      </div>
  );
}

export const NewSearchInput = ({ onChange, showIcon = true, placeholder = "Search", inputClassName, wrapperClassName, isValid = true, ...rest }) => {
  const bgColor = isValid ? "#EFF0FA" : "#FFE1E1";
  return (
    <div
      className={cn(
        `flex items-center rounded-lg max-w-[400px] w-full  h-[40px] px-3`,
        wrapperClassName,
        `bg-[${bgColor}]`
      )}
    >
      {showIcon && <SearchIcon className="font-light size-5" />}
      <input
        required={true}
        placeholder={placeholder}
        className={cn(
          "h-full w-full bg-transparent !pl-2  rounded-lg placeholder:font-light placeholder:text-sm text-base",
          inputClassName,
          `!shadow-[inset_0_0_0_1000px_${bgColor}]`
        )}
        onChange={(evt) => onChange(evt.target.value)}
        type={"text"}
        {...rest}
      />
    </div>
  );
};

export const SearchInput = ({ onChange, showIcon = true, placeholder = "Search", inputClassName, wrapperClassName, isValid = true, ...rest }) => {
    const bgColor = isValid ? "#EFF0FA" : "#FFE1E1";
    return (
        <div
            className={cn(
                `flex items-center rounded-lg max-w-[400px] w-full  h-[40px] px-3`,
                wrapperClassName,
                `bg-[${bgColor}]`
            )}
        >
            {showIcon && <SearchIcon className="font-light size-5" />}
        <InputNumberFormat
                required={true}
                placeholder={placeholder}
                className={cn(
                    "h-full w-full bg-transparent !pl-2  rounded-lg placeholder:font-light placeholder:text-sm text-base",
                    inputClassName,
                    `!shadow-[inset_0_0_0_1000px_${bgColor}]`
                )}
                onChange={(evt) => onChange(evt.target.value)}
                type={"text"}
                {...rest}
            />
        </div>
    );
};

export default TableSearchInput